<template>
  <div v-if="embed">
    <div id="bar">
      <a href="?embed=false" target="shelvist">Shelvist</a>
    </div>
    <div id="main">
      <router-view></router-view>
    </div>
  </div>
  <div v-else id="layout">
    <modal name="dialog" />
    <div id="bar">
      <a href="/">Shelvist</a>
      <page-menu />
    </div>
    <div id="main">
      <router-view></router-view>
      <FlashMessage :position="`left top`"></FlashMessage>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Store from './store';
import PageMenu from './components/PageMenu';

export default {
  components: {
    PageMenu,
  },
  mounted() {
    this.$eventHub.$on('login', (user) => {
      Vue.set(Store, 'user', user);

      this.user = user;

      this.$router.push('dashboard');
    });
  },
  data() {
    return {
      user: Store.user,
      embed:
        !(typeof this.$route.query.embed === 'undefined')
          && this.$route.query.embed !== 'false',
    };
  },
};
</script>
